/* Bussali product page additions (Claude, Nov 2026): trust strip, delivery line, lens guide,
   collapsible specs, and "email my prescription after checkout". */
(function(){
  'use strict';
  var P = window.BL_PRODUCT || {};
  var EMAIL = 'hello@bussali.com';
  var RX_LATER_VALUE = 'Will email after checkout';
  var css = document.createElement('style');
  css.textContent = '.bl-trust{list-style:none;margin:16px 0 8px;padding:14px 16px;border:1px solid #e6e6e6;border-radius:8px;display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;font-size:13px;line-height:1.35;max-width:520px}' +
    '.bl-trust li{position:relative;padding-left:20px}.bl-trust li:before{content:"\\2713";position:absolute;left:0;font-weight:700}' +
    '.bl-deliv{font-size:13px;color:#555;margin:6px 0 18px;max-width:520px}' +
    '.bl-guide{max-width:520px;margin:4px 0 14px;border:1px solid #e6e6e6;border-radius:8px;padding:12px 14px;background:#fafafa}' +
    '.bl-guide summary{cursor:pointer;font-weight:600;font-size:14px}.bl-guide dl{margin:10px 0 0;font-size:13px;line-height:1.45}.bl-guide dt{font-weight:600;margin-top:8px}.bl-guide dd{margin:0;color:#444}' +
    '.bl-guide p{font-size:13px;color:#444;margin:10px 0 0}' +
    '.bl-specs{margin-top:14px;border-top:1px solid #e6e6e6;padding-top:10px}.bl-specs summary{cursor:pointer;font-weight:600}' +
    '.product-single__description .bl-intro{font-size:16px;line-height:1.55}' +
    '.bl-rxmode{flex:0 0 100%;width:100%;margin:6px 0 14px;order:0}' +
    '.bl-rxmode .bl-rx-h{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;margin:0 0 8px}' +
    '.bl-rxmode .bl-rx-opts{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '.bl-rxmode label{display:block;position:relative;border:1px solid #ccc;border-radius:6px;padding:10px 12px;font-size:14px;line-height:1.3;cursor:pointer;background:#fff}' +
    '.bl-rxmode label small{display:block;color:#666;font-size:12px;margin-top:2px}' +
    '.bl-rxmode input{position:absolute;opacity:0;pointer-events:none}' +
    '.bl-rxmode input:checked+span{font-weight:600}' +
    '.bl-rxmode label:has(input:checked){border:2px solid #111;padding:9px 11px}' +
    '.bl-rxmode .bl-rx-note{display:none;margin-top:10px;padding:10px 12px;background:#f6f6f6;border-left:3px solid #111;font-size:13px;line-height:1.45}' +
    '.bl-rxmode.is-later .bl-rx-note{display:block}' +
    '#infiniteoptions-container .bl-rx-hide{display:none!important}' +
    '@media(max-width:749px){.bl-trust{grid-template-columns:1fr}.bl-rxmode .bl-rx-opts{grid-template-columns:1fr}}';
  document.head.appendChild(css);

  function addTrust(){
    var form = document.querySelector('.product-single form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form || document.querySelector('.bl-trust')) return !!form;
    var kering = /kering/i.test(P.vendor || '');
    var items = ['Free FedEx shipping', '30-day returns', 'HSA/FSA accepted', 'Prescription reviewed by a doctor'];
    if (kering) items.push('Authorized Kering Eyewear dealer');
    else items.push('Lenses made in our own lab');
    var ul = document.createElement('ul'); ul.className = 'bl-trust';
    items.forEach(function(t){ var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    var d = document.createElement('p'); d.className = 'bl-deliv';
    d.textContent = 'With prescription lenses, ships in 7–10 business days. Frame only, ships in 2–3 business days. Questions? Email our concierge team.';
    var a = document.createElement('a'); a.href = '/pages/concierge'; a.textContent = ' Contact us';
    d.appendChild(a);
    form.parentNode.insertBefore(ul, form.nextSibling);
    ul.parentNode.insertBefore(d, ul.nextSibling);
    return true;
  }

  function addGuide(){
    var box = document.getElementById('infiniteoptions-container');
    if (!box || document.querySelector('.bl-guide')) return !!box;
    if (!box.querySelector('input[name="properties[Lens Design]"]')) return false;
    var g = document.createElement('details'); g.className = 'bl-guide';
    g.innerHTML = '<summary>Not sure which lens you need? Quick guide</summary>' +
      '<dl><dt>Single Vision</dt><dd>One distance, either far or near. Most people under 40 wear these.</dd>' +
      '<dt>EyeZen Digital</dt><dd>Single vision with a small boost for phones and screens. Great if your eyes feel tired after screen time.</dd>' +
      '<dt>Varilux Immersia</dt><dd>For computer and desk work if you are over 40 and wear readers.</dd>' +
      '<dt>Progressive (Shift, Comfort Max, XR Design)</dt><dd>Far, middle and near in one lens with no line. If your prescription has an ADD power, this is usually the one.</dd>' +
      '<dt>Bifocal or Trifocal</dt><dd>Lined lenses with separate zones, for people who already wear them.</dd>' +
      '<dt>Frame only</dt><dd>No lenses. We ship the frame by itself.</dd></dl>' +
      '<p>Your prescription shows the numbers to enter (Sphere, Cylinder, Axis and ADD). PD is the distance between your pupils, often written on the prescription. Don’t have it handy? Choose “Email it after checkout”. A doctor checks everything before your lenses are made.</p>';
    box.parentNode.insertBefore(g, box);
    return true;
  }

  function specs(){
    var desc = document.querySelector('.product-single__description');
    if (!desc || desc.querySelector('.bl-specs')) return;
    var intro = desc.querySelector('.bl-intro');
    if (!intro) return;
    var rest = []; var n = intro.nextSibling;
    while (n) { rest.push(n); n = n.nextSibling; }
    if (!rest.length) return;
    var det = document.createElement('details'); det.className = 'bl-specs';
    det.innerHTML = '<summary>Frame details and specifications</summary>';
    rest.forEach(function(x){ det.appendChild(x); });
    desc.appendChild(det);
  }

  /* ---------- Email my prescription after checkout ---------- */
  var RX_RE = /Sphere|Cylinder|Axis|PD|Pupil|Add Power/i;
  var rxLater = false, rxBox = null, rxInput = null, applying = false;
  function ioBox(){ return document.getElementById('infiniteoptions-container'); }
  function rxFields(){
    var c = ioBox(); if (!c) return [];
    return Array.prototype.filter.call(c.children, function(d){
      var lab = d.querySelector('.spb-label-tooltip, label');
      return d.querySelector('select') && lab && RX_RE.test(lab.textContent || '');
    });
  }
  function designVal(){
    var c = ioBox(); if (!c) return '';
    var i = c.querySelector('input[name="properties[Lens Design]"]:checked');
    return i ? i.value : '';
  }
  function anyRxShown(){
    return rxFields().some(function(d){ return d.classList.contains('bl-rx-hide') || d.offsetParent !== null; });
  }
  function hiddenInput(on){
    var c = ioBox(); if (!c) return;
    var form = c.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (on) {
      if (!rxInput) { rxInput = document.createElement('input'); rxInput.type = 'hidden'; rxInput.name = 'properties[Prescription]'; rxInput.value = RX_LATER_VALUE; }
      if (rxInput.parentNode !== form) form.appendChild(rxInput);
    } else if (rxInput && rxInput.parentNode) { rxInput.parentNode.removeChild(rxInput); }
  }
  function applyRx(){
    if (applying) return; applying = true;
    try {
      var c = ioBox(); if (!c || !rxBox) return;
      var d = designVal();
      var lensOrder = d && !/Frame only/i.test(d);
      var later = rxLater && lensOrder;
      rxBox.style.display = lensOrder && anyRxShown() ? '' : 'none';
      rxBox.classList.toggle('is-later', later);
      rxFields().forEach(function(f){
        f.classList.toggle('bl-rx-hide', later);
        Array.prototype.forEach.call(f.querySelectorAll('select'), function(s){
          if (later && !s.disabled) { s.disabled = true; s.setAttribute('data-bl-rx-off', '1'); }
          if (!later && s.getAttribute('data-bl-rx-off')) { s.disabled = false; s.removeAttribute('data-bl-rx-off'); }
        });
      });
      hiddenInput(later);
      var msg = document.querySelector('.bl-msg');
      if (msg) msg.style.visibility = later ? 'hidden' : '';
    } finally { applying = false; }
  }
  function addRxMode(){
    var c = ioBox(); if (!c) return false;
    if (rxBox) return true;
    var fields = rxFields(); if (!fields.length) return false;
    rxBox = document.createElement('div'); rxBox.className = 'bl-rxmode';
    rxBox.innerHTML = '<p class="bl-rx-h">Your prescription</p><div class="bl-rx-opts">' +
      '<label><input type="radio" name="bl_rx_mode" value="now" checked><span>Enter it now</span><small>Use the numbers on your prescription</small></label>' +
      '<label><input type="radio" name="bl_rx_mode" value="later"><span>Email it after checkout</span><small>Don’t have it handy? No problem</small></label></div>' +
      '<div class="bl-rx-note">After you check out, email a photo of your prescription to <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> with your order number. Include your PD (pupil distance) if you have it. A doctor reviews it before the lab makes your lenses, and we’ll contact you if anything is missing. Your prescription must be current (generally less than 2 years old).</div>';
    var first = fields[0];
    c.insertBefore(rxBox, first);
    rxBox.addEventListener('change', function(e){ if (e.target.name === 'bl_rx_mode') { rxLater = e.target.value === 'later'; applyRx(); } });
    new MutationObserver(function(){ if (!applying) setTimeout(applyRx, 30); }).observe(c, { attributes: true, attributeFilter: ['style'], subtree: true });
    c.addEventListener('change', function(){ setTimeout(applyRx, 60); }, true);
    applyRx();
    return true;
  }

  var tries = 0;
  (function run(){
    var a = addTrust(), b = addGuide(), r = addRxMode();
    specs();
    if ((!a || !b || !r) && ++tries < 40) setTimeout(run, 300);
  })();
})();
